<template>
  <div
    v-if="fid"
    class="modal-content +blue +large overflow-hidden"
  >
    <div class="hidden md:block">
      <ResponsiveImage
        v-if="fid.image"
        :image="fid.image"
        :width="525"
        alt="current fid"
        loading="lazy"
        class="w-full max-w-xl"
      />
    </div>
    <div class="flex-center flex-col gap-4 text-center md:text-left md:items-start md:pr-8 md:max-w-[280px]">
      <div class="flex flex-col gap-4">
        <span class="font-bold text-green-500">
          {{ $t('products.try_in_development') }}
        </span>
        <div class="text-2xl md:text-3xl font-medium">
          {{ $t('products.you_decide_next_flavor') }}
        </div>
      </div>
      <ResponsiveImage
        v-if="fid.image"
        :image="fid.image"
        :width="525"
        alt="current fid"
        loading="lazy"
        class="md:hidden w-full max-w-md"
      />
      <hr class="border-t border-[#dddddd] w-full">
      <div class="flex flex-col gap-1 items-center md:items-start">
        <span class="font-bold text-green-500">
          {{ $t('products.this_months_flavor') }}
        </span>
        <span class="text-lg font-medium">
          {{ fid.title }}
        </span>
        <button
          class="link text-sm"
          :aria-label="`Nutrition info for ${ fid.title }`"
          data-gtm-action="show nutrition info"
          :data-gtm-label="fid.title"
          @click.prevent="modalActive = true"
        >
          {{ $t('bundler.nutrition_info') }}
        </button>
      </div>
    </div>
  </div>
  <vue-modal
    v-model="modalActive"
    @close="modalActive = false"
  >
    <FidNutritionModal
      :product-title="fid.title"
      :image="fid.nutrition_image"
      :alt="fid.nutrition"
      class="p-4"
    />
  </vue-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { usePidsStore } from '@/stores'
import ResponsiveImage from '../shared/v2/responsive-image.vue'
import FidNutritionModal from '../theme/render/fid-nutrition-modal.vue'

const { fid } = usePidsStore()
const modalActive = ref(false)
defineEmits([ 'close' ])
</script>
